<template>
  <v-form>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <v-btn
      @click="submit"
      id="submit"
    >Update Role Data</v-btn>
  </v-form>
</template>

<script>
export default {
  name: 'SetupAdmin',
  data: () => ({
    _userID: null,
    isError: false,
    errMessage: null
  }),
  props: {
    userID: {
      type: String,
      default: null
    }
  },
  watch: {
    userID: function () {
      this._userID = this.userID
    }
  },
  methods: {
    submit: function () {
      var _this = this
      this.axios.post('/auth/users/' + this._userID + '/roles/admin')
        .then(function () {
          // XXX: Note success?
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
          // Use our standard messages by default, but tweak them to be more
          // specific if appropriate.
          _this.errMessage = msg
          if (err && err.response && err.response.status) {
            switch (err.response.status) {
              case 409:
                _this.errMessage = 'The user already has a role. Please reload the page.'
                break
            }
          }

          _this.isError = true
        }))
    }
  },
  mounted () {
    // Make sure that our internal userID value starts out as equal with our prop value
    this._userID = this.userID
  }
}
</script>
